export default {
  path: '/oferta',
  redirect: { name: 'not-found' },
};
